import React, { Fragment } from 'react'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import Icon from '../tntd-icon'

import Divider from '../divider'
import Dropdown from '../dropdown'
import Menu from '../menu'
import './index.less'

const clsPrefix = 'tntd-more-menus'
export default (props) => {
  return (
    <LocaleReceiver componentName="Handle">
      {(locale, localeCode) => {
        const {
          children = [],
          type,
          num = 3,
          lang,
          divider = true,
          lessOneMoreFit,
          popConfirmHandle,
          isIconBtn,
          ...rest
        } = props || {}

        // 非中文
        let isCn = lang === 'cn'
        if (!lang) {
          isCn = localeCode === 'zh-cn'
        }

        let newChildren = []
        if (Array.isArray(children)) {
          newChildren = children?.filter((item) => !!item) || []
        } else if (children) {
          newChildren.push(children)
        }
        // 子元素大于1个，且不是 icon元素
        const specialSceneDefaultShow = newChildren?.length > 1 && !isIconBtn

        if (specialSceneDefaultShow && (!isCn || popConfirmHandle)) {
          newChildren?.forEach((v, i) => {
            const { type, props } = v
            if (
              type?.name === 'Popconfirm' ||
              (props.hasOwnProperty('onConfirm') && typeof props?.onConfirm === 'function')
            ) {
              let placement = {}
              if (
                !isCn ||
                (num &&
                  !isNaN(num) &&
                  i + 1 > num &&
                  !(lessOneMoreFit && newChildren.length - num === 1))
              ) {
                placement = {
                  placement: 'left',
                }
              }
              newChildren[i] = React.cloneElement(v, {
                overlayStyle: { width: 180 },
                ...(v?.props || {}),
                onClick: (e) => e.stopPropagation(),
                ...placement,
                trigger: 'hover',
                getPopupContainer: (trigger) => trigger.parentNode,
              })
            }
          })
        }

        let [preChildPart, lastChildPart] = [newChildren, null]

        // 只有1个时不适配
        if (lessOneMoreFit && newChildren.length - num === 1) {
          preChildPart = newChildren
        } else if (newChildren && num && !isNaN(num) && newChildren.length > num) {
          preChildPart = newChildren.slice(0, num)
          lastChildPart = newChildren.slice(num)
        }

        if (divider && preChildPart) {
          const preChildLen = preChildPart.length
          preChildPart = preChildPart.map((dom, i) => (
            <Fragment key={i}>
              {dom}
              {!(
                (i === preChildLen - 1 && !lastChildPart?.length) // 没有更多 且 是最后一个时 不显示 Divider
              ) && <Divider type="vertical" />}
            </Fragment>
          ))
        }
        const menu = (childArr) => (
          <Menu className="org-pop-opera-btn">
            {childArr?.map((child, i) => (
              <Menu.Item key={i}>{child}</Menu.Item>
            ))}
          </Menu>
        )

        if (!isCn && specialSceneDefaultShow) {
          return (
            <Dropdown overlay={menu(newChildren || [])} arrow>
              {type === 'icon' ? (
                <Icon type="more" />
              ) : (
                <a className="ant-dropdown-more">
                  {locale?.more}
                  <i className={`${clsPrefix}-dropdown-icon`}>
                    <Icon type="down" />
                  </i>
                </a>
              )}
            </Dropdown>
          )
        }

        return (
          <div
            onClick={(e) => {
              e.stopPropagation()
            }}
            {...rest}
          >
            {preChildPart}
            {!!lastChildPart?.length && (
              <Dropdown overlay={menu(lastChildPart || [])} arrow>
                {type === 'icon' ? (
                  <Icon type="more" />
                ) : (
                  <a className="ant-dropdown-more">
                    {locale?.more}
                    <i className={`${clsPrefix}-dropdown-icon`}>
                      <Icon type="down" />
                    </i>
                  </a>
                )}
              </Dropdown>
            )}
          </div>
        )
      }}
    </LocaleReceiver>
  )
}
